// Generated by Melange

import * as Fx from "../fx/fx.jsx";
import * as MergeIntoMap from "../mergeIntoMap/mergeIntoMap.jsx";
import * as Subsonic__GetSong from "../api/subsonic/getSong.jsx";

function make(id) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const store = param.store;
    const state = store.getState();
    return Fx.Monad_syntax.let$star(Fx.provide(Subsonic__GetSong.make(id), {
      credentials: state.auth.credentials
    }), (function (song) {
      const state = store.getState();
      const byId = MergeIntoMap.mergeIntoMap(state.songs.byId, [song], (function (x) {
        return x.id;
      }));
      if (byId !== state.songs.byId) {
        store.setState(function (prevState) {
          return {
            albums: prevState.albums,
            artists: prevState.artists,
            auth: prevState.auth,
            player: prevState.player,
            songs: {
              byId: byId
            }
          };
        });
      }
      return {
        TAG: /* Ok */ 0,
        _0: undefined
      };
    }));
  }));
}

export {
  make,
}
/* MergeIntoMap Not a pure module */
